<template>
  <div class="menu-node">
    <div class="menu-node-row">
      <button v-if="childItems.length" type="button" class="menu-node-toggle"
              v-b-toggle="'collapse-'+item.id" title="نمایش زیرمجموعه‌ها">
        <b-icon icon="chevron-down"/>
      </button>
      <span v-else class="menu-node-toggle is-leaf"><b-icon icon="dot"/></span>

      <span class="menu-node-icon" :style="item.color ? { color: item.color } : null">
        <img v-if="isIconImage(item.icon_class)" alt="icon_class" :src="item.icon_class"/>
        <b-icon v-else-if="item.icon_class" :icon="item.icon_class"/>
        <b-icon v-else icon="link-45deg"/>
      </span>

      <div class="menu-node-info">
        <div class="menu-node-name">
          <span>{{ item.name }}</span>
          <span class="menus-chip">{{ translateMenuAccess() }}</span>
          <span class="menus-id-chip" title="ترتیب">ترتیب {{ item.order }}</span>
          <span v-if="childItems.length" class="menus-chip is-active">{{ childItems.length }} زیرمجموعه</span>
        </div>
        <span v-if="item.url" class="menu-node-url">{{ item.url }}</span>
      </div>

      <div class="menu-node-actions">
        <button type="button" class="menus-action" title="ویرایش" v-b-modal="'modal-'+item.id">
          <b-icon icon="pen"/>
        </button>
        <button type="button" class="menus-action" title="افزودن زیرمجموعه" v-b-modal="'modal-add-child'+item.id">
          <b-icon icon="plus-lg"/>
        </button>
        <button type="button" class="menus-action is-danger" title="حذف" @click="removeItem(item.id)">
          <b-icon icon="trash"/>
        </button>
      </div>
    </div>

    <b-collapse v-if="childItems.length" :id="'collapse-'+item.id" role="tabpanel">
      <div class="menu-node-children">
        <MenuItem v-for="child in childItems" :key="child.id" :item="child"/>
      </div>
    </b-collapse>

    <b-modal :id="'modal-'+item.id" :ref="'modal-'+item.id" hide-footer centered scrollable hide-header-close
             modal-class="menus-modal" @cancel="resetUpdateItem" @hide="resetUpdateItem">
      <template #modal-header="{ cancel }">
        <menu-modal-header icon="pencil-square" title="ویرایش آیتم" :subtitle="item.name" @close="cancel()"/>
      </template>
      <menu-item-form :item="item" mode="update" @cancel="$bvModal.hide('modal-'+item.id)"/>
    </b-modal>

    <b-modal :id="'modal-add-child'+item.id" hide-footer centered scrollable hide-header-close
             modal-class="menus-modal">
      <template #modal-header="{ cancel }">
        <menu-modal-header icon="diagram-3" title="افزودن زیرمجموعه" :subtitle="`زیر آیتم: ${item.name}`"
                           @close="cancel()"/>
      </template>
      <menu-item-form :item="item" mode="create_sub_item" @cancel="$bvModal.hide('modal-add-child'+item.id)"/>
    </b-modal>

  </div>
</template>

<script>
import FormGroup from "../../validator/FormGroup";
import {required, url} from "vuelidate/lib/validators";
import FormErrorsManager from '../../validator/FormErrorsManager.vue'
import CreateItemChildModalForm from "./CreateItemChildModalForm";
import MenuItemForm from "@/plugin/components/dashboard/menu/MenuItemForm.vue";
import {menuAccessTranslation} from "./MenuItemAccessTranslation";
import MenuModalHeader from "./MenuModalHeader.vue";

export default {
  name: "MenuItem",
  props: ['item'],
  components: {MenuModalHeader, MenuItemForm, FormGroup, FormErrorsManager, CreateItemChildModalForm},
  data() {
    return {
      editItem: {
        id: parseInt(this.item.id),
        menu_id: parseInt(this.$route.params.id),
        status: this.item.status,
        target: this.item.target,
        order: this.item.order,
        parent_id: this.item.parent_id,
        name: this.item.name,
        url: this.item.url,
        icon_class: this.item.icon_class,
        color: this.item.color,
        access: this.item.access,
      }
    }
  },
  validations: {
    editItem: {
      name: {required},
      url: {required},
      color: {required},
      order: {required},
      access: {required},
    }
  },
  computed: {
    childItems() {
      return Array.isArray(this.item.children) ? this.item.children : []
    }
  },
  methods: {
    resetUpdateItem() {
      this.editItem = {
        id: parseInt(this.item.id),
        menu_id: this.$route.params.id,
        status: this.item.status,
        target: this.item.target,
        order: this.item.order,
        parent_id: this.item.parent_id,
        name: this.item.name,
        url: this.item.url,
        icon_class: this.item.icon_class,
        color: this.item.color,
        access: this.item.access,
      }
    },
    removeItem(itemId) {
      let text = "آیا از حذف آیتم اطمینان دارید؟";
      if (confirm(text) === true) {
        this.$store.dispatch("Menu/deleteItem", {id: itemId, menu_id: this.$route.params.id})
      }
    },
    checkParentId() {
      if (this.editItem.parent_id === null) {
        delete this.editItem.parent_id
      } else {
        this.editItem.parent_id = parseInt(this.editItem.parent_id)
      }

    },
    handleOk() {
      this.checkParentId()
      this.$store.dispatch("Menu/updateItem", this.editItem)
    },
    showItem(item) {
      let editItem = {
        id: parseInt(item.id),
        menu_id: item.menu_id,
        target: item.target,
        order: item.order,
        parent_id: item.parent_id,
        name: item.name,
        url: item.url,
        icon_class: item.icon_class,
        color: item.color,
        access: item.access,
      }
      editItem.status = item.status !== 1;

      if (item.parent_id === null) {
        delete editItem.parent_id
      } else {
        editItem.parent_id = parseInt(editItem.parent_id)
      }

      this.$store.dispatch("Menu/updateItem", editItem)
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        this.handleOk()
        this.$nextTick(() => {
          this.$bvModal.hide('modal-' + this.item.id)
          this.resetUpdateItem()
        })
      }
    },
    isIconImage(icon_class) {
      if (icon_class == null) return false
      if (icon_class.indexOf('storage/') > -1) return true
      return false
    },
    removeIcon() {
      if (confirm('آیا از حذف ایکون اطمینان دارید؟')) {
        this.editItem.icon_class = ''
        this.item.icon_class = ''
        this.handleOk();
      }
    },
    translateMenuAccess() {
      return menuAccessTranslation[this.item.access]
    }
  }
}
</script>
